import React from 'react'
import PropTypes from 'prop-types'
import ClientProjectListItem from "./ClientProjectListItem";

const ClientProjectsList = ({projects, canViewFinancialSummary}) => {
    return (
        <div className="d-flex flex-column">
            {projects && projects.map(project => <ClientProjectListItem key={project.project_id} {...project} canViewFinancialSummary={canViewFinancialSummary}/>)}
        </div>
    )
}

ClientProjectsList.propTypes = {
    projects: PropTypes.array,
    canViewFinancialSummary: PropTypes.bool
}

export default ClientProjectsList